// Mode bahasa Inggris (2026-10-24) — untuk rekaman App Review Meta ("use English as the app UI language").
// Bawaan tetap Indonesia. Bila localStorage ui_lang = 'en', teks layar diterjemahkan lewat kamus persis
// (teks UI → English) oleh MutationObserver, jadi komponen yang sudah jalan tidak perlu diubah satu per satu.
// Teks yang tidak ada di kamus dibiarkan apa adanya. Ganti bahasa = simpan pilihan + muat ulang halaman.

const KEY = 'ui_lang';

export function getLang() {
  try { return localStorage.getItem(KEY) === 'en' ? 'en' : 'id'; } catch (_) { return 'id'; }
}
export function setLang(lang) {
  try { localStorage.setItem(KEY, lang === 'en' ? 'en' : 'id'); } catch (_) {}
  window.location.reload();
}

const DICT = {
  // ── Login ──
  'Login gagal': 'Login failed',
  'Selamat Datang': 'Welcome',
  'Login ke dashboard artis kamu': 'Log in to your artist dashboard',
  'Pendaftaran diterima! Akun kamu sedang ditinjau admin. Kami akan mengirim email begitu akunnya aktif — setelah itu kamu bisa login.': 'Registration received! Your account is being reviewed by an admin. We will email you once it is active — then you can log in.',
  'email@kamu.com': 'you@email.com',
  'Lupa password?': 'Forgot password?',
  'Install Starhub Creative App': 'Install Starhub Creative App',
  'Tambahkan ke layar utama untuk akses lebih cepat': 'Add to your home screen for faster access',
  'Belum punya akun?': "Don't have an account?",
  'Daftar sekarang': 'Sign up now',

  // ── Menu & header ──
  // navigasi khas Starhub (tab grup + dock HP)
  'Kelola': 'Manage',
  'Kreasi': 'Create',
  'Buat': 'Create',
  'Statistik': 'Stats',
  'Riwayat': 'History',
  'Profil': 'Profile',
  'Keluar': 'Log out',
  'Akun saya': 'My account',
  'Semua Platform': 'All Platforms',
  'Roster Artis': 'Artist Roster',
  'Tim': 'Team',
  'Persetujuan': 'Approvals',
  'Laporan Artis': 'Artist Reports',
  'Kalender': 'Calendar',
  'Buat konten': 'Create content',
  'Riwayat job': 'Job history',
  'Hubungkan channel': 'Connect channels',
  'Lirik & Narasi': 'Lyrics & Narration',
  'Langganan': 'Subscription',
  'Panduan': 'Guide',
  '🔄 Refresh': '🔄 Refresh',
  'Total Job': 'Total Jobs',
  'Selesai': 'Done',
  'channel perlu reconnect': 'channels need reconnecting',
  'Token beberapa channel YouTube sudah tidak valid. Klik untuk perbaiki.': 'Some YouTube channel tokens are no longer valid. Click to fix.',

  // ── Toast & konfirmasi ──
  'Channel berhasil terhubung!': 'Channel connected successfully!',
  'Akun TikTok berhasil terhubung!': 'TikTok account connected successfully!',
  'Gagal menghubungkan channel (sesi tidak valid). Silakan coba lagi.': 'Failed to connect the channel (invalid session). Please try again.',
  'Sesi login Google sudah kadaluarsa atau terpakai. Silakan coba hubungkan channel lagi.': 'The Google login session has expired or was already used. Please try connecting the channel again.',
  'Akun Google ini tidak punya channel YouTube. Gunakan akun/brand channel yang benar.': 'This Google account has no YouTube channel. Use the correct account/brand channel.',
  'Gagal mengambil data channel YouTube dari Google': 'Failed to fetch YouTube channel data from Google',
  'Gagal menghubungkan channel YouTube. Silakan coba lagi.': 'Failed to connect the YouTube channel. Please try again.',
  'Batas channel tercapai untuk plan kamu. Hubungi admin untuk menambah channel.': 'Channel limit reached for your plan. Contact the admin to add more channels.',
  'Gagal menghubungkan channel YouTube.': 'Failed to connect the YouTube channel.',
  'Job berhasil ditambahkan!': 'Job added successfully!',
  'Gagal submit job': 'Failed to submit job',
  'Semua field wajib diisi': 'All fields are required',
  'Gagal': 'Failed',
  'Gagal upload audio': 'Audio upload failed',
  'Pilih file video dulu': 'Choose a video file first',
  'Judul wajib diisi': 'Title is required',
  'Video berhasil diupload ke antrian!': 'Video uploaded to the queue!',
  'Gagal upload video': 'Video upload failed',
  'Gagal generate URL': 'Failed to generate URL',
  'Gagal menghapus channel': 'Failed to remove channel',
  'Gagal generate URL TikTok': 'Failed to generate TikTok URL',
  'Akun TikTok berhasil diputus': 'TikTok account disconnected',
  'Gagal memutus akun TikTok': 'Failed to disconnect TikTok account',
  'Disconnect semua akun Instagram?': 'Disconnect all Instagram accounts?',
  'Instagram berhasil di-disconnect': 'Instagram disconnected',
  'Gagal disconnect Instagram': 'Failed to disconnect Instagram',
  'API key Postiz berhasil disimpan!': 'Postiz API key saved!',
  'API key tidak valid': 'Invalid API key',
  'Isi judul atau URL dulu': 'Fill in the title or URL first',
  'AI generate gagal': 'AI generate failed',
  'Cookie berhasil diupdate!': 'Cookie updated!',
  'Gagal upload cookie': 'Cookie upload failed',
  'Video tidak tersedia (private/dihapus/dibatasi wilayah). Coba video lain.': 'Video unavailable (private/removed/region-restricted). Try another video.',
  'Cookie YouTube perlu diperbarui. Admin telah diberi tahu.': 'YouTube cookie needs refreshing. The admin has been notified.',
  'Koneksi timeout saat download video. Coba submit ulang.': 'Connection timed out while downloading the video. Try submitting again.',
  'Masalah koneksi proxy. Coba submit ulang.': 'Proxy connection problem. Try submitting again.',
  'Tidak ada channel YouTube aktif. Hubungi admin.': 'No active YouTube channel. Contact the admin.',
  'Gagal posting ke Instagram. Video YouTube tetap terupload.': 'Failed to post to Instagram. The YouTube video was still uploaded.',
  'Terjadi kesalahan sistem. Coba submit ulang atau hubungi admin.': 'A system error occurred. Try submitting again or contact the admin.',
  'Upload terlalu lama dan dihentikan — coba koneksi yang lebih stabil atau perkecil ukuran video': 'Upload took too long and was stopped — try a more stable connection or a smaller video',
  'Tidak bisa terhubung ke server — cek koneksi internet': 'Cannot reach the server — check your internet connection',

  // ── Pemilih tujuan ──
  'dari': 'of',
  'Pilih semua': 'Select all',
  'Kosongkan': 'Clear',
  'Konten ini hanya diposting ke akun yang dicentang ·': 'This content is posted only to the checked accounts ·',
  'akun dipilih': 'accounts selected',
  'perlu reconnect': 'needs reconnect',
  'Pilih minimal satu akun.': 'Select at least one account.',
  'Akun TikTok Tujuan': 'Target TikTok Accounts',
  'Akun Instagram Tujuan': 'Target Instagram Accounts',
  'Channel Tujuan': 'Target Channels',
  'Konten ini hanya dikirim ke channel yang dicentang ·': 'This content is sent only to the checked channels ·',
  'channel dipilih': 'channels selected',
  'Pilih minimal satu channel.': 'Select at least one channel.',
  'Tap untuk lihat profil →': 'Tap to view profile →',
  'aktif': 'active',
  'Pilih dari campaign:': 'Pick from a campaign:',
  'Klik lagi untuk membatalkan pilihan campaign ini': 'Click again to cancel this campaign selection',
  'Centang semua anggota campaign ini': 'Check all members of this campaign',

  // ── Form Buat konten ──
  'Submit URL YouTube': 'Submit YouTube URL',
  'Upload Video': 'Upload Video',
  'Dari URL YouTube': 'From YouTube URL',
  'Sumber lain': 'Other sources',
  'Upload File Video': 'Upload Video File',
  'Klik untuk pilih file MP4': 'Click to choose an MP4 file',
  'Max 80MB · Max 2 menit': 'Max 80MB · Max 2 minutes',
  'File terlalu besar! Max 80MB': 'File too large! Max 80MB',
  '⚠️ Melebihi 2 menit!': '⚠️ Longer than 2 minutes!',
  '⚠️ YouTube Shorts maks 57 detik — potong videonya dulu, atau pilih TikTok/Instagram saja': '⚠️ YouTube Shorts max 57 seconds — trim the video first, or choose TikTok/Instagram only',
  'Judul Video': 'Video Title',
  'Judul video...': 'Video title...',
  'Deskripsi (opsional)': 'Description (optional)',
  'Tags (pisah koma)': 'Tags (comma separated)',
  'Semua': 'All',
  'Compliance YouTube': 'YouTube Compliance',
  'Dibuat untuk anak-anak': 'Made for kids',
  'Wajib diisi sesuai kebijakan YouTube (COPPA)': 'Required by YouTube policy (COPPA)',
  'Mengandung konten AI-generated': 'Contains AI-generated content',
  'Centang jika video menggunakan suara/visual sintetis AI': 'Check if the video uses synthetic AI voice/visuals',
  'Caption Instagram': 'Instagram Caption',
  'Caption IG...': 'IG caption...',
  'Perhatian Hak Cipta': 'Copyright Notice',
  'Audio yang kamu upload adalah tanggung jawab penuh kamu sebagai pengguna. Starhub Creative tidak bertanggung jawab atas klaim hak cipta dari platform YouTube, Instagram, atau TikTok akibat penggunaan audio berlisensi. Pastikan kamu memiliki hak penggunaan atas audio ini.': 'You are fully responsible for the audio you upload. Starhub Creative is not liable for copyright claims from YouTube, Instagram, or TikTok caused by licensed audio. Make sure you have the rights to use this audio.',
  'Saya Mengerti': 'I Understand',
  'Batal': 'Cancel',
  'Tambah Backsound': 'Add Background Music',
  'Tambahkan musik latar ke video kamu': 'Add background music to your video',
  '📁 Upload Sendiri': '📁 Upload Your Own',
  'Library kosong, hubungi admin': 'Library is empty, contact the admin',
  '🎵 Klik untuk pilih file MP3/M4A (max 30MB)': '🎵 Click to choose an MP3/M4A file (max 30MB)',
  'File terlalu besar! Max 30MB': 'File too large! Max 30MB',
  'Audio berhasil diupload!': 'Audio uploaded!',
  '⚠️ Harap setujui disclaimer terlebih dahulu': '⚠️ Please accept the disclaimer first',
  '▶ Mulai Backsound dari': '▶ Start background music at',
  'Play audio sebentar agar durasi terdeteksi': 'Play the audio briefly so the duration is detected',
  '🎵 Volume Backsound': '🎵 Background Music Volume',
  'Penuh (100%)': 'Full (100%)',
  '🎙️ Volume Audio Video Asli': '🎙️ Original Video Audio Volume',
  '📋 Ringkasan:': '📋 Summary:',
  'Backsound mulai': 'Music starts',
  '• Volume Asli': '• Original volume',
  'Tambah Watermark': 'Add Watermark',
  'Overlay logo kamu di pojok kanan atas video': 'Overlay your logo in the top-right corner of the video',
  '🎵 Pengaturan Posting TikTok': '🎵 TikTok Posting Settings',
  'Wajib diisi untuk tiap akun sebelum konten dapat diposting.': 'Required for each account before content can be posted.',
  'Channel dipilih': 'Channel selected',
  'Privacy dipilih': 'Privacy selected',
  'Consent diberikan': 'Consent given',
  'Disclosure konten komersial': 'Commercial content disclosure',
  '⏳ Mengupload...': '⏳ Uploading...',
  '⛔ Lengkapi Compliance TikTok': '⛔ Complete TikTok Compliance',
  '📁 Upload Video ke Antrian': '📁 Upload Video to Queue',
  'Review Sebelum Kirim': 'Review Before Sending',
  '(belum diisi)': '(not filled in)',
  'Platform Tujuan': 'Target Platforms',
  'Dibuat untuk anak-anak:': 'Made for kids:',
  'Ya': 'Yes',
  'Tidak': 'No',
  'Mengandung AI-generated:': 'Contains AI-generated:',
  'Compliance lengkap': 'Compliance complete',
  'Compliance belum lengkap': 'Compliance incomplete',
  'Kembali Edit': 'Back to Edit',
  'Konfirmasi & Posting': 'Confirm & Post',
  'Konfirmasi & Kirim': 'Confirm & Send',
  'Judul Video (opsional)': 'Video Title (optional)',
  'Judul untuk video Shorts...': 'Title for the Shorts video...',
  'Generate subtitle otomatis via Whisper AI': 'Generate subtitles automatically with Whisper AI',
  'Logo client / logo channel ditempel di video': 'Client logo / channel logo is placed on the video',
  'OFF — semua video tanpa logo (proses lebih cepat)': 'OFF — all videos without a logo (faster processing)',
  'Pengaturan Klip': 'Clip Settings',
  'Durasi klip:': 'Clip length:',
  '30 detik': '30 seconds',
  '45 detik': '45 seconds',
  '57 detik': '57 seconds',
  'Bagian video:': 'Video section:',
  '⏮ Awal': '⏮ Start',
  '⏭ Tengah': '⏭ Middle',
  '⏩ Akhir': '⏩ End',
  'Mulai detik ke:': 'Start at second:',
  'mis. 90': 'e.g. 90',
  '🔀 Variasi potongan': '🔀 Clip variations',
  'Tiap ±2 channel/akun dapat potongan dengan titik mulai berbeda, supaya videonya tidak identik.': 'Every ±2 channels/accounts get a clip with a different start point, so the videos are not identical.',
  'Variasi butuh minimal 2 channel/akun tujuan. Pilih tujuan dulu.': 'Variations need at least 2 target channels/accounts. Choose targets first.',
  'Proses jauh lebih lama.': 'Processing takes much longer.',
  'tujuan →': 'targets →',
  'potongan': 'clips',
  ', perkiraan render': ', estimated render',
  'menit': 'minutes',
  '(tiap tujuan dirender terpisah).': '(each target is rendered separately).',
  'Titik mulai dipilih acak (pilihan "Bagian video" diabaikan) dan subtitle otomatis tidak dipakai.': 'Start points are random ("Video section" is ignored) and auto subtitles are not used.',
  '⚠️ Instagram belum terhubung.': '⚠️ Instagram is not connected.',
  'Klik di sini untuk connect →': 'Click here to connect →',
  'Hubungi admin untuk setup akun Instagram.': 'Contact the admin to set up Instagram.',
  '✅ Instagram terhubung': '✅ Instagram connected',
  'Deskripsi video (kosongkan untuk default)...': 'Video description (leave empty for default)...',
  'Tags (opsional, pisah dengan koma)': 'Tags (optional, comma separated)',
  'Caption untuk Instagram Reels...': 'Caption for Instagram Reels...',
  '💡 Sertakan hashtag (#dangdut #shorts) untuk reach lebih luas': '💡 Include hashtags (#music #shorts) for wider reach',
  'Sisa upload hari ini:': 'Uploads left today:',
  'x • Reset 15:00 WIB': 'x • Resets 15:00 WIB',
  'x bonus dari admin': 'x bonus from admin',
  'Jadwal Upload per Channel': 'Upload Schedule per Channel',
  'Kosongkan untuk pakai jadwal default channel': "Leave empty to use the channel's default schedule",
  'Belum ada channel terhubung.': 'No channels connected yet.',
  'Efek default': 'Default effect',
  'Tanpa efek': 'No effect',
  '📸 Jadwal Instagram per Akun': '📸 Instagram Schedule per Account',
  'Kosongkan untuk pakai jadwal default akun.': "Leave empty to use the account's default schedule.",
  '⛔ Limit Harian Tercapai': '⛔ Daily Limit Reached',
  '(otomatis dari YouTube)': '(automatic from YouTube)',
  'Sumber': 'Source',
  'Riwayat Job': 'Job History',
  '(10 terbaru)': '(latest 10)',
  '↑ Tampilkan Sedikit': '↑ Show Less',
  '↓ Lihat Semua': '↓ View All',
  'Belum ada job.': 'No jobs yet.',
  'Tgl': 'Date',
  'Posting TikTok gagal': 'TikTok post failed',
  'Menunggu jadwal posting': 'Waiting for scheduled post',
  'Bahasa judul & deskripsi YouTube (opsional)': 'YouTube title & description language (optional)',
  'Bahasa utama': 'Main language',
  'Otomatis (dideteksi dari judul)': 'Automatic (detected from title)',
  'Judul': 'Title',
  'dan': 'and',
  'Jadwal kirim ke channel YouTube': 'Send schedule to YouTube channels',
  'setelah render selesai': 'after rendering finishes',
  'Langsung': 'Immediately',
  'Bertahap tiap N menit': 'Staggered every N minutes',
  'Acak dalam rentang jam': 'Random within a time window',
  'Mulai': 'Start',
  'Jam tertentu': 'Specific time',
  'Jeda tiap (menit)': 'Gap (minutes)',
  'Dalam rentang (jam)': 'Within (hours)',
  '🎲 Acak ulang': '🎲 Reshuffle',
  'Acak urutan channel': 'Shuffle channel order',
  'dijadwalkan': 'scheduled',
  'Tutup daftar': 'Close list',
  'Lihat jadwal per channel': 'View schedule per channel',
  'Waktu mulai sudah lewat — channel dengan jam yang sudah lewat langsung diproses.': 'Start time has passed — channels with past times are processed immediately.',
  'Jadwal ini menggantikan jam per channel yang diisi manual. Bila job juga ke TikTok/Instagram, keduanya diposting setelah semua channel YouTube selesai.': 'This schedule replaces manually set per-channel times. If the job also goes to TikTok/Instagram, those are posted after all YouTube channels finish.',
  '👁 Preview per Channel': '👁 Preview per Channel',
  'Perkiraan crop & watermark — bukan hasil render final.': 'Approximate crop & watermark — not the final render.',
  'Watermark aktif': 'Watermark on',
  'Tanpa watermark': 'No watermark',
  'dgn watermark': 'with watermark',
  'tanpa watermark': 'without watermark',
  'Tanpa Efek': 'No Effect',
  '🖼️ Cover': '🖼️ Cover',
  '🎨 Dari editor': '🎨 From editor',
  '🎞️ Ambil dari frame': '🎞️ Pick a frame',
  '🖼️ Upload gambar': '🖼️ Upload image',
  'Tanpa cover': 'No cover',
  'Format gambar harus PNG atau JPG': 'Image must be PNG or JPG',
  'Ukuran gambar maksimal 2 MB': 'Image size max 2 MB',
  'Gagal mengunggah gambar cover': 'Failed to upload cover image',
  'Tampil 0,5 detik di awal video dan otomatis jadi sampul TikTok & Reels. Di YouTube Shorts, sampul tetap dipilih YouTube.': 'Shown for 0.5 seconds at the start of the video and automatically used as the TikTok & Reels cover. On YouTube Shorts, YouTube still picks the cover.',
  'Hasil editor ditanam jadi cover di awal video': 'The editor result is burned in as the cover at the start of the video',
  'Hasil editor ditanam jadi cover di awal video.': 'The editor result is burned in as the cover at the start of the video.',
  'Hasil editor ditanam jadi cover di awal video, dan juga dipasang sebagai thumbnail YouTube (channel harus sudah terverifikasi nomor HP).': 'The editor result is burned in as the cover at the start of the video, and also set as the YouTube thumbnail (the channel must be phone-verified).',
  '(opsional)': '(optional)',
  '+ Buat thumbnail': '+ Create thumbnail',
  'Frame di detik ke-': 'Frame at second',
  'Teks hook (opsional,': 'Hook text (optional,',
  'mis. WAJIB DENGAR SAMPAI HABIS': 'e.g. LISTEN TILL THE END',
  'Teks tebal di tengah dengan latar gelap supaya terbaca. Emoji tidak ditampilkan.': 'Bold centered text on a dark background for readability. Emoji are not shown.',
  'Gambar cover': 'Cover image',
  'PNG/JPG, maksimal 2 MB': 'PNG/JPG, max 2 MB',
  'Dipotong otomatis mengikuti ukuran video. Paling pas gambar tegak 1080×1920.': 'Cropped automatically to the video size. A vertical 1080×1920 image fits best.',
  '+ Pilih gambar': '+ Choose image',
  'Belum ada': 'No',
  '— video dikirim tanpa cover.': '— the video is sent without a cover.',
  'Caption TikTok': 'TikTok Caption',
  'Caption + hashtag untuk TikTok...': 'Caption + hashtags for TikTok...',
  'Gagal menyimpan caption': 'Failed to save caption',
  'Edit caption TikTok sebelum terposting': 'Edit the TikTok caption before it is posted',
  'Edit caption TikTok': 'Edit TikTok caption',
  'Tanpa judul': 'Untitled',
  'Akan diposting sebagai:': 'Will be posted as:',
  '(kosong)': '(empty)',
  'Simpan caption': 'Save caption',

  // ── Hubungkan channel ──
  '+ Hubungkan Channel': '+ Connect Channel',
  '▶ Channel YouTube': '▶ YouTube Channels',
  's/d': 'to',
  '🔍 Cari nama channel, email, atau project (mis. "project 02")…': '🔍 Search channel name, email, or project (e.g. "project 02")…',
  'Tidak ada channel yang cocok dengan "': 'No channels match "',
  'Belum ada channel terhubung': 'No channels connected yet',
  'Token expired — hubungkan ulang': 'Token expired — reconnect',
  'Login ulang channel ini. Sistem otomatis memindahkannya ke project Google paling ringan supaya kuota upload tidak cepat penuh. Antrean upload tidak terganggu.': 'Log in to this channel again. The system moves it to the lightest Google project so the upload quota does not fill up quickly. Queued uploads are not affected.',
  '🔄 Hubungkan ulang': '🔄 Reconnect',
  'Pengaturan': 'Settings',
  '🗑️ Hapus': '🗑️ Remove',
  'Akun Instagram': 'Instagram Accounts',
  'Posting otomatis ke Instagram Reels via akun terhubung': 'Automatically post to Instagram Reels through connected accounts',
  '⏳ Menunggu login Instagram di jendela popup… Masuk dengan akun Instagram Profesional lalu klik Izinkan. Jendela akan tertutup otomatis setelah akun terhubung.': '⏳ Waiting for Instagram login in the popup window… Log in with an Instagram Professional account and click Allow. The window closes automatically once the account is connected.',
  '✅ Instagram terhubung: @': '✅ Instagram connected: @',
  'Starhub Creative kini dapat membaca profil akun ini (username & foto profil) dan memposting Reels yang kamu buat di menu Buat konten.': 'Starhub Creative can now read this account\'s profile (username & profile photo) and publish the Reels you create in the Create content menu.',
  'Tutup': 'Close',
  '🔍 Cari akun Instagram…': '🔍 Search Instagram accounts…',
  '+ Tambah Akun Instagram': '+ Add Instagram Account',
  'Disconnect Semua': 'Disconnect All',
  'Akun siap, tapi Instagram belum di-connect.': 'Account ready, but Instagram is not connected yet.',
  'Connect Instagram Sekarang': 'Connect Instagram Now',
  'Akun Instagram belum disetup. Hubungi admin Starhub Creative untuk aktivasi.': 'Instagram is not set up yet. Contact the Starhub Creative admin to activate it.',
  'Punya API Key Postiz?': 'Have a Postiz API key?',
  'Masukkan Postiz API key...': 'Enter Postiz API key...',
  'Simpan': 'Save',
  'Akun TikTok': 'TikTok Accounts',
  'Direct Post aktif (lolos audit TikTok, 12 Okt 2026) — konten diposting sesuai status privasi yang kamu pilih': 'Direct Post active (passed TikTok audit, Oct 12 2026) — content is posted with the privacy status you choose',
  '+ Hubungkan TikTok': '+ Connect TikTok',
  '🔍 Cari akun TikTok…': '🔍 Search TikTok accounts…',
  'Belum ada akun TikTok terhubung': 'No TikTok accounts connected yet',
  'Klik "+ Hubungkan TikTok" untuk mulai': 'Click "+ Connect TikTok" to start',
  '🗑 Putus': '🗑 Disconnect',
  '‹ Sebelumnya': '‹ Previous',
  'Berikutnya ›': 'Next ›',
  'Terhubung': 'Connected',
  'Terhubung ulang': 'Reconnected',
  'Terputus sendiri': 'Disconnected by platform',
  'Dihapus': 'Removed',
  'Dipindah': 'Moved',
  '🕘 Riwayat koneksi': '🕘 Connection history',
  'Catatan akun yang terhubung, terputus sendiri (login ditolak platform), atau kamu hapus — supaya mudah diingat dan dihubungkan lagi.': 'A record of accounts that were connected, disconnected by the platform (login rejected), or removed by you — so they are easy to find and reconnect.',
  'Memuat riwayat…': 'Loading history…',
  'Belum ada catatan. Riwayat mulai tercatat sejak fitur ini aktif.': 'No records yet. History is recorded from the time this feature was enabled.',
  '+ Hubungkan lagi': '+ Connect again',
  '(tanpa nama)': '(no name)',
  'oleh sistem': 'by the system',
  'oleh kamu': 'by you',
  'Artis': 'Artist',
  '-- Belum ter-assign --': '-- Not assigned --',
  'Efek Branding': 'Branding Effect',
  'Paket Profile': 'Profile Pack',
  'Efek Tunggal': 'Single Effect',
  'Jam Upload': 'Upload Time',
  'Jeda (menit)': 'Gap (minutes)',
  'terpasang': 'installed',
  'pakai logo utama': 'use main logo',
  'Ganti': 'Change',
  'Hapus': 'Remove',
  'Simpan Pengaturan': 'Save Settings',
  'Tersimpan': 'Saved',
  'Gagal menyimpan': 'Failed to save',
  'Logo tersimpan': 'Logo saved',
  'Gagal upload logo': 'Logo upload failed',
  'Artis diperbarui': 'Artist updated',
  'Gagal mengubah artis': 'Failed to update artist',
  'Logo dihapus': 'Logo removed',
  'Gagal hapus logo': 'Failed to remove logo',

  // ── Riwayat job / Laporan ──
  '❌ Gagal': '❌ Failed',
  '🕒 Terjadwal': '🕒 Scheduled',
  '✅ Tayang': '✅ Published',
  '⏳ Memproses': '⏳ Processing',
  'Berhasil': 'Success',
  'Proses': 'Processing',
  'Terjadwal': 'Scheduled',
  'URL Sumber': 'Source URL',
  'Tanggal': 'Date',
  'Channel YT Berhasil': 'YT Channels Succeeded',
  'Channel YT Gagal': 'YT Channels Failed',
  'Total Channel YT': 'Total YT Channels',
  'Durasi': 'Duration',
  'Tanpa Judul': 'Untitled',
  'Kredit Terpakai': 'Credits Used',
  'Terhubung Sejak': 'Connected Since',
  'Nonaktif': 'Inactive',
  '📊 Laporan': '📊 Reports',
  'Riwayat upload dan penggunaan AI': 'Upload history and AI usage',
  '📤 Laporan Upload': '📤 Upload Report',
  '✨ Penggunaan AI': '✨ AI Usage',
  '🎵 Akun TikTok': '🎵 TikTok Accounts',
  'Filter Tanggal:': 'Date filter:',
  'Cari': 'Search',
  'Upload Channel': 'Channel Uploads',
  'IG Berhasil': 'IG Success',
  '✅ Berhasil': '✅ Success',
  'Belum ada laporan': 'No reports yet',
  'channel YT': 'YT channels',
  'Detail per Channel YouTube:': 'Details per YouTube channel:',
  '▶ Tonton': '▶ Watch',
  'Detail per akun Instagram:': 'Details per Instagram account:',
  '↗ Lihat di Instagram': '↗ View on Instagram',
  '-- Tidak termasuk campaign --': '-- Not in a campaign --',
  'Total Kredit Terpakai': 'Total Credits Used',
  'Belum ada penggunaan AI': 'No AI usage yet',
  'Kredit': 'Credits',
  'Total Akun': 'Total Accounts',
  'Perlu Reconnect': 'Needs Reconnect',
  'Hubungkan akun TikTok melalui menu Hubungkan channel': 'Connect TikTok accounts from the Connect channels menu',
  'Akun': 'Account',
  '⚠️ Perlu Reconnect': '⚠️ Needs Reconnect',
  '✅ Aktif': '✅ Active',

  // ── Welcome ──
  'Klik tombol hubungkan lalu login dengan akun yang ingin dipakai. Tidak perlu cookie atau ekstensi apa pun.': 'Click the connect button and log in with the account you want to use. No cookies or extensions needed.',
  'Buat konten Shorts': 'Create Shorts content',
  'Tempel link video atau unggah file dari perangkat, pilih channel tujuan, lalu kirim. Sistem memotong, memberi branding, dan mengunggah otomatis.': 'Paste a video link or upload a file from your device, choose target channels, then send. The system trims, brands, and uploads automatically.',
  'Unggah file video dari perangkat, pilih channel tujuan, lalu kirim. Sistem memproses dan mengunggah otomatis.': 'Upload a video file from your device, choose target channels, then send. The system processes and uploads automatically.',
  'Kompilasi video panjang (UGC)': 'Long video compilations (UGC)',
  'Susun beberapa lagu jadi satu video kompilasi lengkap dengan visual & chapter — atau unggah video jadi milikmu sendiri.': 'Arrange several songs into one compilation video with visuals & chapters — or upload your own finished video.',
  'Atur jadwal kirim': 'Set a send schedule',
  'Simpan grup channel sebagai Campaign agar sekali klik.': 'Save channel groups as a Campaign for one-click selection.',
  'Pantau hasilnya': 'Track the results',
  'Lihat status tiap upload di Riwayat job, dan perkembangan views per channel di Analytics.': 'See the status of each upload in Job history, and views per channel in Analytics.',
  'Lihat status tiap upload per channel di Riwayat job.': 'See the status of each upload per channel in Job history.',
  'Upload yang gagal karena kuota penuh atau gangguan sesaat dijadwalkan ulang otomatis — tidak perlu kirim ulang.': 'Uploads that fail due to full quota or a temporary issue are rescheduled automatically — no need to resend.',
  'Channel bertanda "Perlu dihubungkan ulang"? Klik Hubungkan ulang di menu Hubungkan channel.': 'Channel marked "Needs reconnecting"? Click Reconnect in the Connect channels menu.',
  'Batas upload harian mengikuti paket & kuota YouTube, direset sekitar pukul 14.00–15.00 WIB.': 'The daily upload limit follows your plan & YouTube quota, and resets around 14:00–15:00 WIB.',
  'Selamat datang': 'Welcome',
  'Akunmu sudah aktif. Ini': 'Your account is active. Here are',
  'langkah singkat untuk mulai mengunggah.': 'quick steps to start uploading.',
  'Hubungi admin untuk mengaktifkan fitur ini': 'Contact the admin to enable this feature',
  'Buka': 'Open',
  'Perlu diketahui': 'Good to know',
  'Butuh bantuan?': 'Need help?',
  'Mulai: hubungkan channel': 'Start: connect channels',
  'Nanti saja': 'Later',
  'Panduan lengkap selalu ada di menu': 'The full guide is always in the menu',

  // ── Analytics (halaman pertama setelah login) ──
  'baru saja': 'just now',
  'Semua waktu': 'All time',
  '7 hari terakhir': 'Last 7 days',
  '30 hari terakhir': 'Last 30 days',
  'Minggu ini': 'This week',
  'Minggu lalu': 'Last week',
  'Bulan ini': 'This month',
  'Bulan lalu': 'Last month',
  'Pilih tanggal…': 'Pick dates…',
  'Gagal memuat analytics': 'Failed to load analytics',
  'Gagal memuat analytics Instagram': 'Failed to load Instagram analytics',
  'Ringkasan performa video YouTube yang sudah diupload lewat sistem.': 'Performance summary of YouTube videos uploaded through the system.',
  'diperbarui': 'updated',
  'Ambil ulang angka terbaru dari YouTube, tanpa menunggu cache': 'Fetch the latest numbers from YouTube without waiting for the cache',
  'Memuat…': 'Loading…',
  'Muat ulang': 'Reload',
  'Memuat data analytics...': 'Loading analytics data...',
  'Channel YouTube': 'YouTube Channels',
  'terhubung': 'connected',
  'channel belum bisa diperbarui': 'channels could not be refreshed',
  'dari YouTube saat ini, jadi memakai angka terakhir yang berhasil diambil:': 'from YouTube right now, so the last successfully fetched numbers are used:',
  '(belum pernah)': '(never)',
  '. Klik "Muat ulang" beberapa saat lagi.': '. Click "Reload" again in a moment.',
  'Sampai tanggal': 'To date',
  'Dari tanggal': 'From date',
  'Menampilkan video yang': 'Showing videos',
  'terbit': 'published',
  '. Angka views/likes = total video tersebut sampai hari ini.': '. Views/likes = totals for those videos up to today.',
  'Jenis video:': 'Video type:',
  'Periode:': 'Period:',
  'Total Komentar': 'Total Comments',
  'Total Video': 'Total Videos',
  'Rekomendasi Jam Upload:': 'Recommended Upload Time:',
  'Berdasarkan': 'Based on',
  'video, rata-rata': 'videos, average',
  'views di jam ini.': 'views at this hour.',
  'Views per Tanggal Terbit': 'Views by Publish Date',
  'Performa Instagram': 'Instagram Performance',
  'Memuat data Instagram...': 'Loading Instagram data...',
  'Belum ada akun Instagram terhubung — hubungkan dulu di menu Hubungkan channel.': 'No Instagram account connected yet — connect one in the Connect channels menu first.',
  'Komentar': 'Comments',
  'Gagal ambil data akun ini': 'Failed to load data for this account',
  'Performa per Channel YouTube': 'Performance per YouTube Channel',
  'Belum ada video UGC yang bisa dianalisis.': 'No UGC videos to analyze yet.',
  'Belum ada video Shorts yang bisa dianalisis.': 'No Shorts videos to analyze yet.',
  'Belum ada data video yang bisa dianalisis.': 'No video data to analyze yet.',
  'Belum ada video.': 'No videos yet.',
  'Akun Contoh': 'Sample Account',
  'Menunggu izin analytics dari TikTok': 'Waiting for TikTok analytics permission',
  'Perlu dihubungkan ulang': 'Needs reconnecting',
  'Video terbaru': 'Latest videos',
  'Gagal memuat analytics TikTok': 'Failed to load TikTok analytics',
  'Performa TikTok': 'TikTok Performance',
  'Tutup contoh tampilan': 'Close sample view',
  'Lihat contoh tampilan': 'View sample',
  'DATA CONTOH': 'SAMPLE DATA',
  '— bukan data akun sungguhan. Ini pratinjau tampilan setelah izin analytics TikTok (video.list, user.info.stats) disetujui.': '— not real account data. This previews the view after the TikTok analytics permissions (video.list, user.info.stats) are approved.',
  'Belum ada akun TikTok terhubung.': 'No TikTok account connected yet.',
  'Statistik akun & video TikTok membutuhkan izin tambahan (': 'TikTok account & video statistics need additional permissions (',
  ') yang sedang diajukan ke TikTok. Setelah disetujui, hubungkan ulang akun TikTok sekali untuk mengaktifkan bagian ini.': ') that are being requested from TikTok. Once approved, reconnect the TikTok account once to enable this section.',
  'Total Like': 'Total Likes',
  'Jumlah Video': 'Video Count',
  'Views video terbaru': 'Latest video views',

  // ── DNA Channel: tutup pemberitahuan meledak (2026-10-25) ──
  'Hapus semua': 'Clear all',
  'Tutup semua pemberitahuan ini': 'Close all these notifications',
  'Tutup pemberitahuan ini': 'Close this notification',
  'Video baru meledak di channel acuan': 'New viral videos on reference channels',
  'Views per harinya minimal 3× lipat dari biasanya. Lihat lagu, judul, dan thumbnail-nya untuk ide proyek berikutnya. Klik × untuk menutup yang sudah lewat.': 'Daily views at least 3× the usual. Check the song, title and thumbnail for your next project idea. Click × to close ones you are done with.',
  'pemberitahuan lain — tutup yang sudah lewat untuk melihatnya.': 'more notifications — close older ones to see them.',
  'Hapus semua pemberitahuan video meledak? Pemberitahuan baru tetap muncul saat ada video meledak berikutnya.': 'Clear all viral video notifications? New ones will still appear when the next video goes viral.',

  // ── Langganan (header/kartu yang bisa ikut terekam) ──
  'Subscription Aktif': 'Active Subscription',
  'Pilih Plan': 'Choose Plan',
  '🔄 Perpanjang': '🔄 Renew',
  '✅ Laporan': '✅ Reports',
};

// Teks dinamis (template literal di kode) — [pola, pengganti]
const POLA = [
  [/^Persetujuan \((\d+)\)$/, 'Approvals ($1)'],
  [/^Akun Instagram @(.+) berhasil terhubung$/, 'Instagram account @$1 connected successfully'],
  [/^Channel "(.+)" berhasil terhubung ulang!$/, 'Channel "$1" reconnected successfully!'],
  [/^Putuskan akun TikTok @(.+)\?$/, 'Disconnect TikTok account @$1?'],
  [/^✨ AI generate berhasil! Sisa kredit: (.+)$/, '✨ AI generate succeeded! Credits left: $1'],
  [/^✨ AI Generate \((\d+) kredit\)$/, '✨ AI Generate ($1 credits)'],
  [/^Hubungkan akun (.+)$/, 'Connect $1 accounts'],
  [/^Kosongkan untuk memakai judul: "(.*)"$/, 'Leave empty to use the title: "$1"'],
  [/^Permintaan gagal \((.+)\)$/, 'Request failed ($1)'],
  [/^Hapus channel "(.+)" dari daftar\? .*/, 'Remove channel "$1" from the list? Video history is kept. Queued uploads to this channel are cancelled. You can reconnect it anytime with "+ Connect Channel".'],
  [/^(\d+) channel$/, '$1 channels'],
  [/^Akses Instagram kedaluwarsa\/dicabut — hubungkan ulang akun ini\.(.*)$/, 'Instagram access expired or revoked — reconnect this account.$1'],
  [/^Gagal dipublikasikan di Instagram$/, 'Failed to publish on Instagram'],
  [/^(\d+) menit lalu$/, '$1 min ago'],
  [/^(\d+) jam lalu$/, '$1 h ago'],
  [/^(\d+) hari lalu$/, '$1 days ago'],
  [/^termasuk (\d+) UGC$/, 'including $1 UGC'],
  [/^Contoh video (\d) — cuplikan lagu$/, 'Sample video $1 — song snippet'],
  [/^Gagal dimuat \((.+)\)$/, 'Failed to load ($1)'],
  [/^· (\d+) perlu reconnect$/, '· $1 need reconnect'],
];

const ATRIBUT = ['placeholder', 'title', 'alt', 'aria-label'];

function terjemah(teks) {
  if (!teks) return null;
  const inti = teks.replace(/\s+/g, ' ').trim();
  if (!inti) return null;
  let hasil = Object.prototype.hasOwnProperty.call(DICT, inti) ? DICT[inti] : null;
  if (hasil === null) {
    for (const [re, ganti] of POLA) { if (re.test(inti)) { hasil = inti.replace(re, ganti); break; } }
  }
  if (hasil === null || hasil === inti) return null;
  const awal = teks.match(/^\s*/)[0], akhir = teks.match(/\s*$/)[0];
  return awal + hasil + akhir;
}

function lewati(el) {
  return !el || el.closest?.('script,style,textarea,[contenteditable="true"],[data-no-translate]');
}

function terjemahNode(node) {
  if (node.nodeType === 3) {
    if (lewati(node.parentElement)) return;
    const t = terjemah(node.nodeValue);
    if (t !== null) node.nodeValue = t;
    return;
  }
  if (node.nodeType !== 1 || lewati(node)) return;
  for (const a of ATRIBUT) {
    if (node.hasAttribute(a)) { const t = terjemah(node.getAttribute(a)); if (t !== null) node.setAttribute(a, t); }
  }
  if (node.tagName === 'INPUT' && /^(button|submit)$/i.test(node.type)) {
    const t = terjemah(node.value); if (t !== null) node.value = t;
  }
  const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
  let n = walker.nextNode();
  while (n) { if (n !== node) terjemahNode1(n); n = walker.nextNode(); }
}
// versi tanpa turun lagi ke anak (walker sudah mengurusnya)
function terjemahNode1(n) {
  if (n.nodeType === 3) {
    if (lewati(n.parentElement)) return;
    const t = terjemah(n.nodeValue); if (t !== null) n.nodeValue = t;
  } else if (n.nodeType === 1 && !lewati(n)) {
    for (const a of ATRIBUT) {
      if (n.hasAttribute(a)) { const t = terjemah(n.getAttribute(a)); if (t !== null) n.setAttribute(a, t); }
    }
  }
}

export function startTranslator() {
  if (getLang() !== 'en' || typeof window === 'undefined') return;
  document.documentElement.lang = 'en';

  // Tanggal & jam ikut English (kode memakai 'id-ID' secara eksplisit)
  const ubahLocale = (fn) => function (locale, opts) { return fn.call(this, locale === 'id-ID' || locale === 'id' ? 'en-US' : locale, opts); };
  Date.prototype.toLocaleDateString = ubahLocale(Date.prototype.toLocaleDateString);
  Date.prototype.toLocaleTimeString = ubahLocale(Date.prototype.toLocaleTimeString);
  Date.prototype.toLocaleString = ubahLocale(Date.prototype.toLocaleString);

  const asliConfirm = window.confirm.bind(window), asliAlert = window.alert.bind(window);
  window.confirm = (m) => asliConfirm(terjemah(String(m)) ?? m);
  window.alert = (m) => asliAlert(terjemah(String(m)) ?? m);

  const mulai = () => {
    terjemahNode(document.body);
    new MutationObserver((list) => {
      for (const m of list) {
        if (m.type === 'characterData') terjemahNode1(m.target);
        else if (m.type === 'attributes') terjemahNode1(m.target);
        else m.addedNodes.forEach(terjemahNode);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATRIBUT });
  };
  if (document.body) mulai(); else document.addEventListener('DOMContentLoaded', mulai);
}
